import React from "react";
import CopyRight from "./img/copyright.png";
export const Footer = () => {
  return (
    <div>
      <img src={CopyRight} />
    </div>
  );
};
